import { FastWarrantiesService } from './../../../services/fast-warranties.service';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { FastQuoteDialogComponent } from './../../../dialogs/fast-quote-dialog/fast-quote-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ShortenedWarranty } from './../../../models/shortened-warranty.model';
import { UtilsService } from './../../../services/utils.service';
import { GuarantiesService } from './../../../services/guaranties.service';
import { Component, OnInit, ViewChild, ViewEncapsulation, ElementRef, OnDestroy } from '@angular/core';
import { ErrorResponse } from '../../../models/error.model';
import { WarrantyStatusStats } from '../../../models/warranty-stats.model';
import Chart from 'chart.js/auto';

@Component({
    selector: 'app-broker-home',
    templateUrl: './broker-home.component.html',
    styleUrls: ['./broker-home.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class BrokerHomeComponent implements OnInit, OnDestroy {

    @ViewChild('warrantyStatusChart', { static: true })
    warrantyStatusChart: ElementRef<HTMLCanvasElement>;

    latestWarranties?: ShortenedWarranty[];
    warrantyStatusChartData?: WarrantyStatusStats;

    fastWarrantyFG = new UntypedFormGroup({
        inquilino: new UntypedFormGroup({
            nombre: new UntypedFormControl('', [Validators.required]),
            telefono: new UntypedFormControl('', [Validators.required]),
            documento: new UntypedFormControl('', []),
            email: new UntypedFormControl('', []),
        }),
        propietario: new UntypedFormGroup({
            nombre: new UntypedFormControl('', [Validators.required]),
            telefono: new UntypedFormControl('', [Validators.required]),
            documento: new UntypedFormControl('', []),
            email: new UntypedFormControl('', []),
        }),
        propiedad: new UntypedFormGroup({
            codigoRemax: new UntypedFormControl('', []),
            direccion: new UntypedFormControl('', []),
        })
    });

    get fastWarrantyTenantFG() {
        return this.fastWarrantyFG.controls.inquilino as UntypedFormGroup;
    }

    get fastWarrantyOwnerFG() {
        return this.fastWarrantyFG.controls.propietario as UntypedFormGroup;
    }

    get fastWarrantyPropertyFG() {
        return this.fastWarrantyFG.controls.propiedad as UntypedFormGroup;
    }

    chart?: Chart<'pie', number[], string>;

    constructor(
        private guarantiesService: GuarantiesService,
        private utilsService: UtilsService,
        private dialog: MatDialog,
        private fastWarrantiesService: FastWarrantiesService,
    ) { }

    ngOnInit(): void {
        this.getLatestWarranties();
        this.getWarrantyStatusChartData();
    }

    ngOnDestroy(): void {
        if (this.chart) {
            this.chart.destroy();
        }
    }

    getLatestWarranties() {
        this.guarantiesService.getGuarantees(0, 5, [], {}).subscribe({
            next: response => {
                this.latestWarranties = response.body;
            },
            error: (error: ErrorResponse) => this.utilsService.alert('Error al obtener últimas garantías', error.error?.descripcion)
        });
    }

    getWarrantyStatusChartData() {
        this.guarantiesService.getStatusStats().subscribe({
            next: response => {
                this.warrantyStatusChartData = response;
                this.generateWarrantyStatusChart(response);
            },
            error: (error: ErrorResponse) => this.utilsService.alert('Error al obtener estadísticas', error.error?.descripcion)
        });
    }

    generateWarrantyStatusChart(data: WarrantyStatusStats) {
        const sortedStates = ['DOCUMENTACION', 'PAGO_PENDIENTE', 'GENERAR_CONTRATO', 'AUTORIZACION_PENDIENTE', 'FIRMA_DIGITAL', 'FIRMA_PENDIENTE', 'ACTIVA', 'BAJA_ANTICIPADA', 'BAJA_POR_ADMIN', 'BAJA_POR_AGENTE'];
        const sortedStateNames = ['Documentación', 'Pago', 'Contrato', 'Autorizaciones', 'Firma digital', 'Firma', 'Activa', 'Baja anticipada', 'Baja por admin', 'Baja por agente'];
        const colors = ['#6929c4', '#1192e8', '#005d5d', '#9f1853', '#fa4d56', '#570408', '#198038', '#002d9c', '#ee538b', '#b28600', '#009d9a']; // Por si se agregan estados: #012749, #8a3800, #a56eff
        this.chart = new Chart(this.warrantyStatusChart.nativeElement, {
            type: 'pie',
            data: {
                labels: sortedStateNames,
                datasets: [{
                    label: 'Cantidad de garantías',
                    data: sortedStates.map(state => data.estados.find(e => e.estado === state)?.cantidad ?? 0),
                    backgroundColor: colors
                }]
            },
            options: {
                plugins: {
                    legend: {
                        position: 'bottom'
                    }
                }
            }
        });
    }

    openFastQuoteDialog() {
        this.dialog.open(FastQuoteDialogComponent, { width: '900px' });
    }

    sendFastWarranty() {
        this.fastWarrantyFG.markAllAsTouched();
        if (!this.fastWarrantyFG.valid) return;
        this.fastWarrantiesService.newFastWarranty(this.fastWarrantyFG.getRawValue()).subscribe({
            next: _ => {
                this.fastWarrantyFG.reset({
                    inquilino: {
                        nombre: '',
                        telefono: '',
                        documento: '',
                        email: ''
                    },
                    propietario: {
                        nombre: '',
                        telefono: '',
                        documento: '',
                        email: ''
                    },
                    propiedad: {
                        codigoRemax: '',
                        direccion: ''
                    }
                });
                this.utilsService.alert('Garantía derivada correctamente', 'Se han informado a garantor los datos, ellos se contactarán con los involucrados y comenzarán la garantía.');
            },
            error: (error: ErrorResponse) => this.utilsService.alert('Error al generar garantía', error.error?.descripcion)
        });
    }

}
